import { h, render, Component } from 'preact';
import './map-tools-control.scss';
import { LayersTools } from './map-tools-layers';
import { AddressSearchTool } from './map-tool-address-search';
import L from 'leaflet';

export class Tools extends Component {
    constructor(props) {
        super(props);

        this.state = {
            zoom: 0,
            showLayersTools: false,
            activeTool: null,
        };
        this.isSwitchOnAddressDetect = this.props.options.isSwitchOnAddressDetect !== undefined ?
                                       this.props.options.isSwitchOnAddressDetect:
                                       true;
        this.isSwitchOnPrint = this.props.options.isSwitchOnPrint !== undefined ?
                                       this.props.options.isSwitchOnPrint:
                                       true;                                      
        this.onOpenLayerTool.bind(this);
        this.onOpenAddressSearchTool.bind(this);
        document.addEventListener('geofence:startEdit', (event) => {
            this.refreshActiveTool();
            this.setState({ activeTool: null });
        });
        document.addEventListener('map:togglemeasure', () => {
            if (!this.map.measure.getMeasuring()) {
                this.setState({ activeTool: null });
            }
        });

        this.isWestPanelCollapsed = false;
    }

    componentDidMount() {
        this.map = this.props.map;
        this.initZoomEndHandler(this.map);
        this.setState({ zoom: this.map.getZoom() });
    }

    onZoomIn() {
        this.map.zoomIn();
    }

    onZoomOut() {
        this.map.zoomOut();
    }

    onOpenLayerTool(showLayersTools) {
        this.refreshActiveTool();
        this.setState({
            showLayersTools: showLayersTools,
            activeTool: showLayersTools ? 'layersTools' : null
        });
    }

    onOpenAddressSearchTool(isAddressSearchToolOpen) {
        this.refreshActiveTool();
        this.setState({
            isAddressSearchToolOpen: isAddressSearchToolOpen,
            activeTool: isAddressSearchToolOpen ? 'addressSearch' : null
        });
    }

    onDetectAddress() {
        this.refreshActiveTool();
        if (this.state.activeTool != 'addressService') {
            this.map.addressService.toggleAddress();
        }
        this.setState({ activeTool: this.map.addressService.enable ? 'addressService' : null });
    }

    onMeasureDistance() {
        this.refreshActiveTool();
        if (this.state.activeTool != 'measure') {
            this.map.measure._toggleMeasure();
        }
        this.setState({ activeTool: this.map.measure._measuring ? 'measure' : null });
    }

    onPrintMap() {
        var SELF = this;
        var collapsePanel = function () {
            return new Promise(function (resolve) {
                SELF.isWestPanelCollapsed = Ext.ComponentQuery.query('app-main')[0].lookupReference('westPanel').getCollapsed();
                Ext.ComponentQuery.query('app-main')[0].lookupReference('westPanel').collapse();
                setTimeout(function(){
                    resolve();
                }, 1000);
           });
        };

        var afterPrint = function(mql) {
            if (!mql.matches) {
                !SELF.isWestPanelCollapsed && Ext.ComponentQuery.query('app-main')[0].lookupReference('westPanel').expand();
                mediaQueryList.removeListener(afterPrint);
            }
        };

        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(afterPrint);
        }
        
        collapsePanel().then(() => {
            window.print();
        });
    }

    initZoomEndHandler(map) {
        map.on("zoomend", (e) => {
            this.setState({ zoom: map.getZoom() });
        });
    }

    refreshActiveTool() {
        switch (this.state.activeTool) {
            case 'measure':
                this.map.measure._toggleMeasure();
                break;
            case 'addressService':
                this.map.addressService.toggleAddress();
                break;
            case 'addressSearch':
                break;
            case 'layersTools':
                break;
        }
    }

    render(props, state) {
        return (
            <div class="map-toolbar" style={"top:" + this.props.options.position.top + "px;" + "right:" + this.props.options.position.right + "px;"}>
                <div class="map-toolbar__wrapper" >
                    <div class="map-toolbar__btn fm-tooltip" onClick={e => this.onZoomIn()}>
                        <i class="icon-mapwork---glass-plus"></i>
                        <div class="map-toolbar__tooltip fm-tooltip__tip">
                            {messages["zoom_in_map"]}
                        </div>
                    </div>
                    <div class="map-toolbar__btn map-toolbar__btn--number">
                        {state.zoom}
                    </div>
                    <div class="map-toolbar__btn fm-tooltip" onClick={e => this.onZoomOut()}>
                        <i class="icon-mapwork---glass"></i>
                        <div class="map-toolbar__tooltip fm-tooltip__tip">
                            {messages["zoom_out_map"]}
                        </div>
                    </div>
                    <div class={this.state.activeTool == 'layersTools' ? "map-toolbar__btn map-toolbar__btn--active" : "map-toolbar__btn fm-tooltip"}>
                        <i class="icon-mapwork---map" onClick={e => this.onOpenLayerTool(true)}></i>
                        <div class="map-toolbar__tooltip fm-tooltip__tip">
                            {messages["map"]}
                        </div>
                        {
                            this.state.showLayersTools &&
                            <LayersTools markersService={this.props.markersService} geofenceService={this.props.geofenceService} map={this.map} changeLayer={this.map.setBaseLayer} openLayerTool={this.onOpenLayerTool.bind(this)} />
                        }
                    </div>
                    <div class={this.state.activeTool == 'measure' ? "map-toolbar__btn fm-tooltip map-toolbar__btn--active" : "map-toolbar__btn fm-tooltip"}>
                        <i class="icon-mapwork---ruler" onClick={e => this.onMeasureDistance()}></i>
                        <div class="map-toolbar__tooltip fm-tooltip__tip">
                            {messages["distance_measure"]}
                        </div>
                    </div>
                    {   this.isSwitchOnAddressDetect &&
                        <div class={this.state.activeTool == 'addressService' ? "map-toolbar__btn fm-tooltip map-toolbar__btn--active" : "map-toolbar__btn fm-tooltip"}>
                            <i class="icon-mapwork---address" onClick={e => this.onDetectAddress()}></i>
                            <div class="map-toolbar__tooltip fm-tooltip__tip">
                                {messages["address_definition"]}
                            </div>
                        </div>
                    }
                    <div class={this.state.activeTool == 'addressSearch' ? "map-toolbar__btn map-toolbar__btn--active" : "map-toolbar__btn fm-tooltip"}>
                        <i class="icon-mapwork---search" onClick={e => this.onOpenAddressSearchTool(true)}></i>
                        <div class="map-toolbar__tooltip fm-tooltip__tip">
                            {messages["address_serch"]}
                        </div>
                        {
                            this.state.isAddressSearchToolOpen &&
                            <AddressSearchTool map={this.props.map} openAddressSearchTool={this.onOpenAddressSearchTool.bind(this)} />
                        }
                    </div>
                    {   this.isSwitchOnPrint &&
                        <div class="map-toolbar__btn fm-tooltip">
                            <i class="icon-mapwork---print" onClick={e => this.onPrintMap()}></i>
                            <div class="map-toolbar__tooltip fm-tooltip__tip">
                                {messages["Print"]}
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}
